import auth0 from "auth0-js";
import appconfig from "@/appconfig";

const auth0js = new auth0.WebAuth({
  domain: appconfig.domain,
  clientID: appconfig.clientid,
  audience: appconfig.audience,
  scope: appconfig.scope,
  responseType: appconfig.responsetype,
  redirectUri: appconfig.redirecturi
});

const auth0jslib = {
  checkSession: () => {
    return new Promise((resolve, reject) => {
      auth0js.checkSession({}, function(err, authResult) {
        if (err) {
          reject(err);
        } else {
          resolve(authResult);
        }
      });
    });
  },
  userInfo: (token: any) => {
    return new Promise((resolve, reject) => {
      auth0js.client.userInfo(token, (err, profile) => {
        if (err) {
          reject(err);
        } else {
          resolve(profile);
        }
      });
    });
  }
};

export default auth0jslib;
